howspace.widgets.pdf = (() => {
    'use strict';

    const setLastViewedPage = (widget, page) => {
        if (widget.find('.pdf-wrapper').length === 0) {
            return;
        }

        let seenPages = widget.data('seen-pages');

        if (seenPages.includes(page)) {
            return;
        }

        const dataPayload = {
            last_viewed_page: page
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/views', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            showErrorNotification: false,
            success: () => {
                seenPages.push(page);
                widget.dataAndAttr('seen-pages', seenPages);
            }
        });
    };

    howspace.widgets.onEvent('pdf:default-page:updated', (widget, notification) => {
        if (widget.find('.stop-sync-btn').length > 0) {
            return;
        }

        howspace.components.pdfViewer.showPage(widget.find('.howspace-pdf-viewer'), notification.object.widget.default_page);
        howspace.components.pdfViewer.pdfJsShowPage($('.fullscreen-viewer-modal .howspace-pdf-viewer'), notification.object.widget.default_page);
    });

    const handleDocumentDownloaded = (widget) => {
        const pdfDocumentId = widget.find('.howspace-pdf-viewer').data('uploadedfile-id');
        if (!pdfDocumentId) {
            return;
        }

        const dataPayload = {
            pdf_document: pdfDocumentId
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/download', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
        });
    };

    const initConfirmTakeControlModal = (modal, modalOpener) => {
        modal = $(modal);
        const widget = $(modalOpener).closest('.widget');

        modal.find('.modal-footer .btn-success').on('click', () => {
            const dataPayload = {
                user_who_is_presenting: real.dom.$body.data('user-id'),
                default_page: howspace.components.pdfViewer.getCurrentPage(widget.find('.howspace-pdf-viewer'))
            }

            real.ajax.json(howspace.widgets.getApiUrl(widget), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                complete: () => {
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    const pushSync = (widget, page) => {
        if (widget.find('.stop-sync-btn').length === 0) {
            return;
        }

        const dataPayload = {
            workspace: real.dom.$body.data('workspace-id'),
            default_page: page
        }

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/sync', {
            type: 'POST',
            data: JSON.stringify(dataPayload)
        });
    };

    return {
        initView: widget => {
            howspace.annotation.initView(widget);

            // Page loading event.
            widget.on(howspace.components.pdfViewer.PAGE_LOADING, (e) => {
                howspace.annotation.handlePageLoading(widget);
                pushSync(widget, e.detail.page);
            });

            // Page ready event.
            widget.on(howspace.components.pdfViewer.PAGE_READY, (e) => {
                setLastViewedPage(widget, e.detail.page);
                howspace.annotation.handlePageChanged(widget, e.detail.page);
                if (e.detail.page === widget.find('.howspace-pdf-viewer').data('page-count')) {
                    howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
                }
            });

            // Document downloaded event.
            widget.on(howspace.components.pdfViewer.DOCUMENT_DOWNLOADED, () => {
                handleDocumentDownloaded(widget);
            });

            // Start presenting button.
            widget.find('.start-sync-btn').on('click', () => {
                const dataPayload = {
                    user_who_is_presenting: real.dom.$body.data('user-id'),
                    default_page: howspace.components.pdfViewer.getCurrentPage(widget.find('.howspace-pdf-viewer'))
                }

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                });
            });

            // Stop presenting button.
            widget.find('.stop-sync-btn').on('click', () => {
                const dataPayload = {
                    user_who_is_presenting: null,
                    default_page: 1
                }

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                });
            });

            // Set the first page as viewed.
            setLastViewedPage(widget, 1);
        },
        destroyView: widget => {
            howspace.annotation.destroyView(widget);
        },
        initEdit: widget => {
            howspace.annotation.initEdit(widget);

            // PDF uploaded event.
            widget.on(howspace.components.fileUploader.UPLOAD_COMPLETED, (e) => {
                const uploadedFileId = e.detail.uploadedFiles[0].id;

                real.ajax.html(howspace.widgets.getUrl(widget) + '/pdf/' + uploadedFileId, {
                    type: 'GET',
                    success: (response) => {
                        const pdfCard = widget.find('.pdf-card .card-content');
                        pdfCard.html($(response));
                        howspace.components.init(pdfCard);
                    }
                });
            });

            // Delete PDF button.
            widget.on('click', '.delete-pdf-btn', () => {
                // Hide the current PDF.
                const currentPdf = widget.find('.current-pdf');
                currentPdf.velocity('slideUp', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => {
                        currentPdf.remove();
                    }
                });

                // Hide the delete container.
                const deleteContainer = widget.find('.delete-pdf-container');
                deleteContainer.velocity('slideUp', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => {
                        deleteContainer.addClass('d-none');
                    }
                });

                // Show the PDF uploader.
                const fileUploader = widget.find('.howspace-file-uploader');
                fileUploader.velocity('slideDown', {
                    duration: howspace.getAnimationDuration(widget, '--animation-duration'),
                    complete: () => [
                        fileUploader.removeClass('d-none')
                    ]
                });

                // Update the form value.
                widget.find('input[name="pdf_document"]').val('');
            });

            // Permanently anonymous checkbox.
            widget.find('.anonymity-checkbox').on('change', e => {
                const checkbox = widget.find('.filter-checkbox');
                if (e.target.checked) {
                    howspace.form.disable(checkbox);
                    checkbox.find('input').prop('checked', false);
                } else {
                    howspace.form.enable(checkbox);
                }
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            dataPayload.pinning_options = [];
            const pinningOptionsWithoutTitle = [];
            widget.find('.option:not(.deleted)').each(function () {
                const optionPayload = real.form.getDataPayload($(this));
                if (optionPayload.title) {
                    dataPayload.pinning_options.push(optionPayload);
                } else {
                    pinningOptionsWithoutTitle.push(optionPayload);
                }
            });

            if (pinningOptionsWithoutTitle.length > 0 && dataPayload.pinning_mode === 'pin') {
                real.notification.show(howspace.translate('common_pinning_option_fill_in_a_title'), 'danger');
                return false;
            }

            return dataPayload;
        },
        initFileUploaderModal: (modal, modalOpener) => {
            const widget = $(modalOpener).closest('.widget');

            modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
                howspace.widgets.pdf.handleFileUploadCompleted(modal, e.detail.uploadedFiles[0], widget);
            });
        },
        handleFileUploadCompleted: (modal, uploadedFile, widget) => {
            if (widget.data('widget-mode') === 'view') {
                const dataPayload = {
                    pdf_document: uploadedFile.id
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type: 'POST',
                    data: JSON.stringify(dataPayload)
                });

                howspace.components.modal.close(modal);
            }
        },
        updateFilter: (widget) => {
            const pdfViewer = widget.find('.howspace-pdf-viewer');
            const page = howspace.components.pdfViewer.getCurrentPage(pdfViewer);

            howspace.annotation.getPins(widget, page);
        },
        startAnnotating: () => {},
        stopAnnotating: () => {},
        initConfirmTakeControlModal: initConfirmTakeControlModal
    }
})();
